import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseMutateResource } from '../../utils/types';

type QuoteInput = TrpcInputs['deleteQuote'];
type QuoteOutput = TrpcOutputs['deleteQuote'];

type DeleteQuoteFunction = MutateFunction<QuoteInput, QuoteOutput>;
type UseDeleteQuote = UseMutateResource<DeleteQuoteFunction>;

export const useDeleteQuote = (id: number): UseDeleteQuote => {
  const { mutateAsync, isLoading, error } = trpc.deleteQuote.useMutation();
  const handleDelete: DeleteQuoteFunction = async () => await mutateAsync({ id } as any);

  return [handleDelete, isLoading, error?.message];
};
